// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Zelda Universe Configuration
 * 
 * The land of Hyrule - a realm of legend where the Triforce awaits.
 * Ancient magic flows through every system, and courage, wisdom, and power
 * guide the destiny of all who venture here.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { ZeldaAliensPlanets } from './AliensConfig';

export const universeZelda = {
  id: 'zelda',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: ZeldaAliensPlanets,
  spaceStations: [],
  stationPositions: {}
};

export default universeZelda;